import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import {
    getCouponById,
    updateCoupon,
} from "../services/adminApi";

import CouponForm from "../components/coupons/CouponForm";

const EditCoupon = () => {

    const { id } = useParams();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [coupon, setCoupon] = useState(null);

    useEffect(() => {
        loadCoupon();
    }, []);

    const loadCoupon = async () => {
        try {
            const res = await getCouponById(id);
            setCoupon(res.data.coupon);
        } catch (err) {
            console.error(err);
        }
    };

    const handleSubmit = async (values) => {
        try {
            setLoading(true);

            await updateCoupon(id, values);

            alert("Coupon updated successfully.");

            navigate("/admin/coupons");

        } catch (err) {
            console.error(err);
            alert("Failed to update coupon.");
        } finally {
            setLoading(false);
        }
    };

    if (!coupon) return <p>Loading...</p>;

    return (
        <CouponForm
            title="Edit Coupon"
            initialValues={coupon}
            loading={loading}
            onSubmit={handleSubmit}
        />
    );
};

export default EditCoupon;